import appConfig from "../../../appConfig";

// ─── Chart palette ────────────────────────────────────────────────────────────
// Google Charts requires raw hex strings — CSS variables are not supported
// inside the options object, so we maintain a separate palette constant here.

/** @type {Record<string, string>} */
const CHART_COLORS =
  appConfig.branding === "rev"
    ? {
        brand500: "#CB65D0",
        brand600: "#B146B3",
        grey100: "#F5F5F5",
        grey200: "#E9EAEB",
        grey400: "#A4A7AE",
        grey500: "#717680",
        grey800: "#252B37",
        error500: "#F04438",
      }
    : {
        brand500: "#2970FF",
        brand600: "#155EEF",
        grey100: "#F5F5F5",
        grey200: "#E9EAEB",
        grey400: "#A4A7AE",
        grey500: "#717680",
        grey800: "#252B37",
        error500: "#F04438",
      };
export default CHART_COLORS;
